import React from "react";
import { RegistryItem } from "../lib/supabase";
import ConfirmationDialog from "./ConfirmationDialog";
import useConfirmationDialog from "../hooks/useConfirmationDialog";

interface RegistryItemsTableProps {
  items: RegistryItem[];
  onDelete: (itemId: string) => void;
  onEdit: (item: RegistryItem) => void;
}

const RegistryItemsTable: React.FC<RegistryItemsTableProps> = ({
  items,
  onDelete,
  onEdit,
}) => {
  const { dialogState, showConfirmation, handleConfirm, handleCancel } =
    useConfirmationDialog();

  const handleDelete = (itemId: string) => {
    showConfirmation(
      {
        title: "Delete Registry Item",
        message:
          "Are you sure you want to delete this registry item? This action cannot be undone.",
        confirmText: "Delete",
        cancelText: "Cancel",
        type: "danger",
      },
      () => onDelete(itemId)
    );
  };

  return (
    <>
      <div className="items-table">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Price</th>
              <th>Category</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td>
                  <span className={`type-badge ${item.type}`}>
                    {item.type === "external_link"
                      ? "External Link"
                      : "Regular Item"}
                  </span>
                </td>
                <td>${item.price}</td>
                <td>{item.category}</td>
                <td>
                  <span
                    className={`status ${
                      item.purchased ? "purchased" : "available"
                    }`}
                  >
                    {item.purchased ? "Purchased" : "Available"}
                  </span>
                </td>
                <td>
                  <div className="action-buttons">
                    <button onClick={() => onEdit(item)} className="edit-btn">
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(item.id)}
                      className="delete-btn"
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <ConfirmationDialog
        isOpen={dialogState.isOpen}
        title={dialogState.title}
        message={dialogState.message}
        confirmText={dialogState.confirmText}
        cancelText={dialogState.cancelText}
        type={dialogState.type}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </>
  );
};

export default RegistryItemsTable;
